// Typelizer digest 1a83842501cbebb1c4de4f6866e57b74
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /api/portals/projects */
  projects: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/api/portals/projects', {}, options),
    method: 'get',
  }),

  /** POST /api/portals/:slug/toggle_published */
  togglePublished: (
    params: { slug: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/api/portals/:slug/toggle_published', params, options),
    method: 'post',
  }),

  /** GET /api/portals */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/api/portals', {}, options),
    method: 'get',
  }),

  /** POST /api/portals */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/api/portals', {}, options),
    method: 'post',
  }),

  /** GET /api/portals/:slug */
  show: (
    params: { slug: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/api/portals/:slug', params, options),
    method: 'get',
  }),

  /** PATCH /api/portals/:slug */
  update: (
    params: { slug: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/api/portals/:slug', params, options),
    method: 'patch',
  }),

  /** DELETE /api/portals/:slug */
  destroy: (
    params: { slug: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/api/portals/:slug', params, options),
    method: 'delete',
  }),
}
